"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardsGridSortProvider = exports.DashboardsDefaultSortField = exports.DashboardsDefaultDirections = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
exports.DashboardsDefaultDirections = {
    [catalog_queries_1.DashboardOrderField.NAME]: catalog_queries_1.OrderDirection.ASC,
};
exports.DashboardsDefaultSortField = catalog_queries_1.DashboardOrderField.NAME;
function DashboardsGridSortProvider(props) {
    return (react_1.default.createElement(data_catalog_shared_1.UrlSortProvider, { validOrderFieldsWithDefaultDirections: exports.DashboardsDefaultDirections, defaultField: exports.DashboardsDefaultSortField }, props.children));
}
exports.DashboardsGridSortProvider = DashboardsGridSortProvider;
//# sourceMappingURL=DashboardsGridSortProvider.js.map